import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string, bool, func, number, oneOfType } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { useLuContentContext } from '../LuContentContext';
import { Container, Content, ArrowBackContainer, LuContentSocialMedias, LuImage, LuExplainContent, LogoLuExplain, Title, LinkMoreContent } from './LuContentHeader.styles';

const LuContentHeader = _ref => {
  let {
    title,
    subtitle,
    showBackButton,
    onBackButtonClick,
    linkToMoreContentLabel,
    showLinkToMoreContent,
    showSocialMedias,
    onSocialMediaClick,
    iconName
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "subtitle", "showBackButton", "onBackButtonClick", "linkToMoreContentLabel", "showLinkToMoreContent", "showSocialMedias", "onSocialMediaClick", "iconName"]);

  const titleText = subtitle || title;
  const {
    images: {
      luImage,
      luExplainImage
    } = {},
    linkToMoreContent
  } = useLuContentContext() || {};
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, _extends({
    showBackButton: showBackButton,
    "data-testid": "lu-explain-header-container"
  }, props), /*#__PURE__*/React.createElement(ArrowBackContainer, null, showBackButton && /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    color: "#ffffff",
    "data-testid": "lu-header-close",
    role: "button",
    title: "Voltar",
    tabIndex: "1",
    onClick: onBackButtonClick,
    cursor: "pointer"
  })), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(LuImage, {
    src: luImage,
    alt: "personagem Lu do magazineluiza apontando para o logo lu explica",
    width: 60,
    height: 80,
    lazy: true
  }), /*#__PURE__*/React.createElement(LuExplainContent, null, /*#__PURE__*/React.createElement(LogoLuExplain, {
    src: luExplainImage,
    alt: "Lu Explica",
    width: 127,
    height: 24,
    lazy: true
  }), titleText && /*#__PURE__*/React.createElement(Title, {
    tiny: !!subtitle
  }, titleText), showLinkToMoreContent && /*#__PURE__*/React.createElement(LinkMoreContent, {
    "data-testid": "lu-explain-more-content",
    href: linkToMoreContent
  }, linkToMoreContentLabel)), showSocialMedias && /*#__PURE__*/React.createElement(LuContentSocialMedias, {
    onSocialMediaClick: onSocialMediaClick
  }))));
};

LuContentHeader.defaultProps = {
  title: '',
  subtitle: null,
  showBackButton: false,
  onBackButtonClick: () => {},
  linkToMoreContentLabel: '+ Veja outros conteúdos',
  showLinkToMoreContent: false,
  showSocialMedias: false,
  onSocialMediaClick: () => {},
  iconName: 'ArrowBack'
};
process.env.NODE_ENV !== "production" ? LuContentHeader.propTypes = {
  title: string,
  subtitle: string,
  showBackButton: bool,
  onBackButtonClick: func,
  borderRadius: oneOfType([string, number]),
  linkToMoreContentLabel: string,
  showLinkToMoreContent: bool,
  showSocialMedias: bool,
  onSocialMediaClick: func,
  iconName: string
} : void 0;
export default LuContentHeader;